exports.f = require('./_wks');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/_wks-ext.js
// module id = R1u4
// module chunks = 10